// extracted by mini-css-extract-plugin
export default {"container":"MawashiKupovi_container__pHC6c","naslov":"MawashiKupovi_naslov__sbyYp"};